import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { GridColumn } from "../export-data.component";
import { columnTitlesMap } from "../export-data.constants";
import { Helicopter } from "../../shared/models/helicopter.model";
import { FlightsService } from "../../flights-calendar/flights.service";
import { LocalStorageService, UserLocalStorageObject } from "../../shared/local-storage.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FilterConfirmDialogComponent } from "./filter-confirm-dialog/filter-confirm-dialog.component";

@Component({
    selector: "app-export-data-columns-dialogue",
    templateUrl: "./export-data-columns-dialogue.component.html",
    styleUrls: ["./export-data-columns-dialogue.component.scss"],
    standalone: false,
})
export class ExportDataColumnsDialogueComponent {
    private _userSession: UserLocalStorageObject;

    public hideAll: boolean = false;
    public isCamo: boolean = false;

    constructor(
        private _flightsService: FlightsService,
        private _localStorageService: LocalStorageService,
        public dialogRef: MatDialogRef<ExportDataColumnsDialogueComponent>,
        private _dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            gridColumns: GridColumn[];
            currentHelicopter: Helicopter;
            hasPresetFilters: boolean;
            presetFilter?: any;
        },
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
        if (this._userSession.htlAccountTypes.length > 0) {
            switch (this._userSession.htlAccountTypes[0].id) {
                case 1:
                    this.isCamo = true;
                    break;
                case 2:
                    this.isCamo = true;
                    break;
            }
        }
    }

    onClose() {
        this.dialogRef.close();
    }

    public hideColumnsBasedOnHelicopterData(def: string): boolean {
        if (def === "totalCycles") return !this.data.currentHelicopter?.sumHooksCycles;
        if (def.includes("engine2")) return !this.data.currentHelicopter?.hasEngine2;
        return false;
    }

    public hideSubgroupBasedOnHelicopterData(id: any): boolean {
        if (id === "e2" || id === "Δe2") return !this.data.currentHelicopter?.hasEngine2;
        return false;
    }

    public getColumnTitleById(id: string): string {
        return columnTitlesMap.get(id) || "";
    }

    toggleGroup(id: string) {
        this.data.gridColumns.find((g) => g.id === id)?.columns.forEach((c) => (c.hidden = !c.hidden));
    }

    toggleAll() {
        this.hideAll = !this.hideAll;
        this.data.gridColumns.forEach((c) => {
            if (c.groupedColumns) {
                c.groupedColumns.forEach((gc) => {
                    gc.columns.forEach((col) => (col.hidden = this.hideAll));
                });
            } else {
                c.columns.forEach((col) => (col.hidden = this.hideAll));
            }
        });
    }

    public onCheckboxToggle(c) {
        c.hidden = !c.hidden;
    }

    public saveFilterPreset() {
        const dialogRef = this._dialog.open(FilterConfirmDialogComponent, {
            width: "360px",
            data: {
                delete: false,
                presetFilterName: this.data.presetFilter?.name,
            },
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (res && res.filterName) {
                const visibleColumns: string[] = [];
                this.data.gridColumns.forEach((c) => {
                    if (c.groupedColumns) {
                        c.groupedColumns.forEach((gc) => {
                            gc.columns.forEach((col) => {
                                if (!col.hidden) {
                                    visibleColumns.push(col.def);
                                }
                            });
                        });
                    } else {
                        c.columns.forEach((col) => {
                            if (!col.hidden) {
                                visibleColumns.push(col.def);
                            }
                        });
                    }
                });
                this._flightsService
                    .saveExportPresetFilter(this._userSession.organizationId, res.filterName, visibleColumns, this.data.presetFilter ? this.data.presetFilter.id : 0)
                    .subscribe((res) => {
                        this.dialogRef.close({ newFilter: res });
                    });
            }
        });
    }

    public deleteFilterPreset() {
        const dialogRef = this._dialog.open(FilterConfirmDialogComponent, {
            width: "360px",
            data: {
                delete: true,
            },
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (res) {
                this._flightsService.deleteExportPresetFilter(this.data.presetFilter.id).subscribe((res) => {
                    this.dialogRef.close({ filterDeleted: this.data.presetFilter });
                });
            }
        });
    }
}
